var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2075F0",
    d: "M12.692 3.176H6.467a2.3 2.3 0 0 0-2.3 2.3v7.908a2.3 2.3 0 0 0 2.3 2.3h6.225c1.274 0 2.3-1.025 2.3-2.3V5.476c0-1.275-1.026-2.3-2.3-2.3m.966 10.208a.967.967 0 0 1-.966.967H6.467a.967.967 0 0 1-.967-.967V5.476c0-.534.433-.967.966-.967h6.225c.534 0 .967.433.967.967z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2075F0",
    d: "M5.5 11.668H4.267v1.333H5.5zM8.225.492H2.617A2.607 2.607 0 0 0 .008 3.101v7.291a2.607 2.607 0 0 0 2.609 2.609H3.1v-1.334h-.483a1.275 1.275 0 0 1-1.275-1.275V3.101a1.27 1.27 0 0 1 1.275-1.275h5.608c.233 0 .458.066.65.183h1.717A2.6 2.6 0 0 0 8.233.492z"
  })));
};
export default SvgCopy;